export default __webpack_public_path__ + "d13810b7b51f6ecae9acfa8543c3bcf6.png";